/** @TJS-type number */
export class UserId {
  private constructor() {}

  "UserId": UserId;

  public static wrap(id: number): UserId {
    return <any>id;
  }

  public static unwrap(userId: UserId): number {
    return <any>userId;
  }
}

/** @TJS-type number */
export class AgencyId {
  private constructor() {}

  "AgencyId": AgencyId;

  public static wrap(id: number): AgencyId {
    return <any>id;
  }

  public static unwrap(agencyId: AgencyId): number {
    return <any>agencyId;
  }
}

/** @TJS-type number */
export class ComplianceItemId {
  private constructor() {}

  "ComplianceItemId": ComplianceItemId;

  public static wrap(id: number): ComplianceItemId {
    return <any>id;
  }

  public static unwrap(id: ComplianceItemId): number {
    return <any>id;
  }
}

/** @TJS-type number */
export class PlanOfCareId {
  private constructor() {}

  "PlanOfCareId": PlanOfCareId;

  public static wrap(id: number): PlanOfCareId {
    return <any>id;
  }

  public static unwrap(planOfCareId: PlanOfCareId): number {
    return <any>planOfCareId;
  }
}

/** @TJS-type number */
export class PlanOfCareItemId {
  private constructor() {}

  "PlanOfCareItemId": PlanOfCareItemId;

  public static wrap(id: number): PlanOfCareItemId {
    return <any>id;
  }

  public static unwrap(planOfCareItemId: PlanOfCareItemId): number {
    return <any>planOfCareItemId;
  }
}

/** @TJS-type number */
export class PlanOfCareItemAnswerId {
  private constructor() {}

  "PlanOfCareItemAnswerId": PlanOfCareItemAnswerId;

  public static wrap(id: number): PlanOfCareItemAnswerId {
    return <any>id;
  }

  public static unwrap(planOfCareItemAnswerId: PlanOfCareItemAnswerId): number {
    return <any>planOfCareItemAnswerId;
  }
}

/** @TJS-type number */
export class CaregiverNotificationId {
  private constructor() {}

  "CaregiverNotificationId": CaregiverNotificationId;

  public static wrap(id: number): CaregiverNotificationId {
    return <any>id;
  }

  public static unwrap(caregiverNotificationId: CaregiverNotificationId): number {
    return <any>caregiverNotificationId;
  }
}

/** @TJS-type number */
export class AgencyMemberId {
  private constructor() {}

  "AgencyMemberId": AgencyMemberId;

  public static wrap(id: number): AgencyMemberId {
    return <any>id;
  }

  public static unwrap(agencyMemberId: AgencyMemberId): number {
    return <any>agencyMemberId;
  }
}

/** @TJS-type number */
export class InsurerMemberId {
  private constructor() {}

  "InsurerMemberId": InsurerMemberId;

  public static wrap(id: number): InsurerMemberId {
    return <any>id;
  }

  public static unwrap(insurerMemberId: InsurerMemberId): number {
    return <any>insurerMemberId;
  }
}

/** @TJS-type number */
export class InsurerId {
  private constructor() {}

  "InsurerId": InsurerId;

  public static wrap(id: number): InsurerId {
    return <any>id;
  }

  public static unwrap(insurerId: InsurerId): number {
    return <any>insurerId;
  }
}

/** @TJS-type number */
export class VisitBroadcastId {
  private constructor() {}

  "VisitBroadcastId": VisitBroadcastId;

  public static wrap(id: number): VisitBroadcastId {
    return <any>id;
  }

  public static unwrap(visitBroadcastId: VisitBroadcastId): number {
    return <any>visitBroadcastId;
  }
}

/** @TJS-type number */
export class OnboardingVisitId {
  private constructor() {}

  "OnboardingVisitId": OnboardingVisitId;

  public static wrap(id: number): OnboardingVisitId {
    return <any>id;
  }

  public static unwrap(onboardingVisitId: OnboardingVisitId): number {
    return <any>onboardingVisitId;
  }
}

/** @TJS-type number */
export class OnboardingVisitInstanceId {
  private constructor() {}

  "OnboardingVisitInstanceId": OnboardingVisitInstanceId;

  public static wrap(id: number): OnboardingVisitInstanceId {
    return <any>id;
  }

  public static unwrap(onboardingVisitInstanceId: OnboardingVisitInstanceId): number {
    return <any>onboardingVisitInstanceId;
  }
}

/** @TJS-type number */
export class ClusterId {
  private constructor() {}

  "ClusterId": ClusterId;

  public static wrap(id: number): ClusterId {
    return <any>id;
  }

  public static unwrap(id: ClusterId): number {
    return <any>id;
  }
}

/** @TJS-type number */
export class ImportedVisitId {
  private constructor() {}

  "ImportedVisitId": ImportedVisitId;

  public static wrap(id: number): ImportedVisitId {
    return <any>id;
  }

  public static unwrap(importedVisitId: ImportedVisitId): number {
    return <any>importedVisitId;
  }
}

/** @TJS-type number */
export class ScheduledVisitEditRequestId {
  private constructor() {}

  "ScheduledVisitEditRequestId": ScheduledVisitEditRequestId;

  public static wrap(id: number): ScheduledVisitEditRequestId {
    return <any>id;
  }

  public static unwrap(scheduledVisitEditRequestId: ScheduledVisitEditRequestId): number {
    return <any>scheduledVisitEditRequestId;
  }
}

/** @TJS-type number */
export class CaregiverVisitEngagementId {
  private constructor() {}

  "CaregiverVisitEngagementId": CaregiverVisitEngagementId;

  public static wrap(id: number): CaregiverVisitEngagementId {
    return <any>id;
  }

  public static unwrap(caregiverVisitEngagementId: CaregiverVisitEngagementId): number {
    return <any>caregiverVisitEngagementId;
  }
}

/** @TJS-type number */
export class CaregiverId {
  private constructor() {}

  "CaregiverId": CaregiverId;

  public static wrap(id: number): CaregiverId {
    return <any>id;
  }

  public static unwrap(caregiverId: CaregiverId): number {
    return <any>caregiverId;
  }
}

/** @TJS-type number */
export class ReferralSourceId {
  private constructor() {}

  "ReferralSourceId": ReferralSourceId;

  public static wrap(id: number): ReferralSourceId {
    return <any>id;
  }

  public static unwrap(referralSourceId: ReferralSourceId): number {
    return <any>referralSourceId;
  }
}

/** @TJS-type number */
export class SocialWorkerId {
  private constructor() {}

  "SocialWorkerId": SocialWorkerId;

  public static wrap(id: number): SocialWorkerId {
    return <any>id;
  }

  public static unwrap(socialWorkerId: SocialWorkerId): number {
    return <any>socialWorkerId;
  }
}

/** @TJS-type number */
export class CaregiverPhonenumberId {
  private constructor() {}

  "CaregiverPhonenumberId": CaregiverPhonenumberId;

  public static wrap(id: number): CaregiverPhonenumberId {
    return <any>id;
  }

  public static unwrap(val: CaregiverPhonenumberId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class CaregiverLastSeenId {
  private constructor() {}

  "CaregiverLastSeenId": CaregiverLastSeenId;

  public static wrap(id: number): CaregiverLastSeenId {
    return <any>id;
  }

  public static unwrap(caregiverLastSeenId: CaregiverLastSeenId): number {
    return <any>caregiverLastSeenId;
  }
}

/** @TJS-type number */
export class CaregiverAgencyAssocId {
  private constructor() {}

  "CaregiverAgencyAssocId": CaregiverAgencyAssocId;

  public static wrap(id: number): CaregiverAgencyAssocId {
    return <any>id;
  }

  public static unwrap(caregiverAgencyAssocId: CaregiverAgencyAssocId): number {
    return <any>caregiverAgencyAssocId;
  }
}

/** @TJS-type number */
export class ChatRoomId {
  private constructor() {}

  "ChatRoomId": ChatRoomId;

  public static wrap(id: number): ChatRoomId {
    return <any>id;
  }

  public static unwrap(val: ChatRoomId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class ChatMessageId {
  private constructor() {}

  "ChatMessageId": ChatMessageId;

  public static wrap(id: number): ChatMessageId {
    return <any>id;
  }

  public static unwrap(val: ChatMessageId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class ChatMessageViewedId {
  private constructor() {}

  "ChatMessageViewedId": ChatMessageViewedId;

  public static wrap(id: number): ChatMessageViewedId {
    return <any>id;
  }

  public static unwrap(val: ChatMessageViewedId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class VisitChatRoomId {
  private constructor() {}

  "VisitChatRoomId": VisitChatRoomId;

  public static wrap(id: number): VisitChatRoomId {
    return <any>id;
  }

  public static unwrap(val: VisitChatRoomId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class AgencyMemberCaregiverChatRoomId {
  private constructor() {}

  "AgencyMemberCaregiverChatRoomId": AgencyMemberCaregiverChatRoomId;

  public static wrap(id: number): AgencyMemberCaregiverChatRoomId {
    return <any>id;
  }

  public static unwrap(val: AgencyMemberCaregiverChatRoomId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class InternalAgencyChatRoomId {
  private constructor() {}

  "InternalAgencyChatRoomId": InternalAgencyChatRoomId;

  public static wrap(id: number): InternalAgencyChatRoomId {
    return <any>id;
  }

  public static unwrap(val: InternalAgencyChatRoomId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class SmsLinkCodeId {
  private constructor() {}

  "SmsLinkCodeId": SmsLinkCodeId;

  public static wrap(id: number): SmsLinkCodeId {
    return <any>id;
  }

  public static unwrap(val: SmsLinkCodeId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class SendSmsJobId {
  private constructor() {}

  "SendSmsJobId": SendSmsJobId;

  public static wrap(id: number): SendSmsJobId {
    return <any>id;
  }

  public static unwrap(val: SendSmsJobId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class SentSmsId {
  private constructor() {}

  "SentSmsId": SentSmsId;

  public static wrap(id: number): SentSmsId {
    return <any>id;
  }

  public static unwrap(val: SentSmsId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class UserFcmRegistrationTokenId {
  private constructor() {}

  "UserFcmRegistrationTokenId": UserFcmRegistrationTokenId;

  public static wrap(id: number): UserFcmRegistrationTokenId {
    return <any>id;
  }

  public static unwrap(val: UserFcmRegistrationTokenId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class FcmJobQueueId {
  private constructor() {}

  "FcmJobQueueId": FcmJobQueueId;

  public static wrap(id: number): FcmJobQueueId {
    return <any>id;
  }

  public static unwrap(val: FcmJobQueueId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class UploadJobId {
  private constructor() {}

  "UploadJobId": UploadJobId;

  public static wrap(id: number): UploadJobId {
    return <any>id;
  }

  public static unwrap(val: UploadJobId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class HRQuestionId {
  private constructor() {}

  "HRQuestionId": HRQuestionId;

  public static wrap(id: number): HRQuestionId {
    return <any>id;
  }

  public static unwrap(val: HRQuestionId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class HRSectionId {
  private constructor() {}

  "HRSectionId": HRSectionId;

  public static wrap(id: number): HRSectionId {
    return <any>id;
  }

  public static unwrap(val: HRSectionId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class HRSubSectionId {
  private constructor() {}

  "HRSubSectionId": HRSubSectionId;

  public static wrap(id: number): HRSubSectionId {
    return <any>id;
  }

  public static unwrap(val: HRSubSectionId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class HRQuestionGroupId {
  private constructor() {}

  "HRQuestionGroup": HRQuestionGroupId;

  public static wrap(id: number): HRQuestionGroupId {
    return <any>id;
  }

  public static unwrap(val: HRQuestionGroupId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class HRDocumentId {
  private constructor() {}

  "HRDocumentId": HRDocumentId;

  public static wrap(id: number): HRDocumentId {
    return <any>id;
  }

  public static unwrap(val: HRDocumentId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class HRDocumentTypeId {
  private constructor() {}

  "HRDocumentTypeId": HRDocumentTypeId;

  public static wrap(id: number): HRDocumentTypeId {
    return <any>id;
  }

  public static unwrap(val: HRDocumentTypeId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class HRSectionStageId {
  private constructor() {}

  "HRSectionStageId": HRSectionStageId;

  public static wrap(id: number): HRSectionStageId {
    return <any>id;
  }

  public static unwrap(val: HRSectionStageId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class PayRateSupplementalId {
  private constructor() {}

  "PayRateSupplementalId": PayRateSupplementalId;

  public static wrap(id: number): PayRateSupplementalId {
    return <any>id;
  }

  public static unwrap(val: PayRateSupplementalId): number {
    return <any>val;
  }
}

/** @TJS-type string */
export class HRQuestionTemplateId {
  private constructor() {}

  "HRQuestionTemplateId": HRQuestionTemplateId;

  public static wrap(id: string): HRQuestionTemplateId {
    return <any>id;
  }

  public static unwrap(val: HRQuestionTemplateId): string {
    return <any>val;
  }
}

/** @TJS-type number */
export class PatientId {
  private constructor() {}

  "PatientId": PatientId;

  public static wrap(id: number): PatientId {
    return <any>id;
  }

  public static unwrap(val: PatientId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class PatientClinicalInfoId {
  private constructor() {}

  "PatientClinicalInfoId": PatientClinicalInfoId;

  public static wrap(id: number): PatientClinicalInfoId {
    return <any>id;
  }

  public static unwrap(val: PatientClinicalInfoId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class TreatmentId {
  private constructor() {}

  "TreatmentId": TreatmentId;

  public static wrap(id: number): TreatmentId {
    return <any>id;
  }

  public static unwrap(val: TreatmentId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class ContractTypeId {
  private constructor() {}

  "ContractTypeId": ContractTypeId;

  public static wrap(id: number): ContractTypeId {
    return <any>id;
  }

  public static unwrap(val: ContractTypeId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class ContractId {
  private constructor() {}

  "ContractId": ContractId;

  public static wrap(id: number): ContractId {
    return <any>id;
  }

  public static unwrap(val: ContractId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class ServiceCodeId {
  private constructor() {}

  "ServiceCodeId": ServiceCodeId;

  public static wrap(id: number): ServiceCodeId {
    return <any>id;
  }

  public static unwrap(val: ServiceCodeId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class PhysicianId {
  private constructor() {}

  "PhysicianId": PhysicianId;

  public static wrap(id: number): PhysicianId {
    return <any>id;
  }

  public static unwrap(val: PhysicianId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class TreatmentMedicalOrderId {
  private constructor() {}
  "TreatmentMedicalOrderId": TreatmentMedicalOrderId;
  public static wrap(id: number): TreatmentMedicalOrderId {
    return <any>id;
  }
  public static unwrap(val: TreatmentMedicalOrderId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class TreatmentAdvanceDirectiveId {
  private constructor() {}
  "TreatmentAdvanceDirectiveId": TreatmentAdvanceDirectiveId;
  public static wrap(id: number): TreatmentAdvanceDirectiveId {
    return <any>id;
  }
  public static unwrap(val: TreatmentAdvanceDirectiveId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class TreatmentDiagnosisId {
  private constructor() {}
  "TreatmentDiagnosisId": TreatmentDiagnosisId;
  public static wrap(id: number): TreatmentDiagnosisId {
    return <any>id;
  }
  public static unwrap(val: TreatmentDiagnosisId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class VisitTypeId {
  private constructor() {}

  "VisitTypeId": VisitTypeId;

  public static wrap(id: number): VisitTypeId {
    return <any>id;
  }

  public static unwrap(val: VisitTypeId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class PatientDocumentTypeId {
  private constructor() {}
  "PatientDocumentTypeId": PatientDocumentTypeId;
  public static wrap(id: number): PatientDocumentTypeId {
    return <any>id;
  }
  public static unwrap(id: PatientDocumentTypeId): number {
    return <any>id;
  }
}

/** @TJS-type number */
export class PatientDocumentVersionId {
  private constructor() {}
  "PatientDocumentVersionId": PatientDocumentVersionId;
  public static wrap(id: number): PatientDocumentVersionId {
    return <any>id;
  }
  public static unwrap(id: PatientDocumentVersionId): number {
    return <any>id;
  }
}

/** @TJS-type number */
export class PatientDocumentAnswersId {
  private constructor() {}
  "PatientDocumentAnswersId": PatientDocumentAnswersId;
  public static wrap(id: number): PatientDocumentAnswersId {
    return <any>id;
  }
  public static unwrap(id: PatientDocumentAnswersId): number {
    return <any>id;
  }
}

/** @TJS-type number */
export class RecruitmentCaregiverApplicationQuestionId {
  private constructor() {}

  "RecruitmentCaregiverApplicationQuestionId": RecruitmentCaregiverApplicationQuestionId;

  public static wrap(id: number): RecruitmentCaregiverApplicationQuestionId {
    return <any>id;
  }

  public static unwrap(val: RecruitmentCaregiverApplicationQuestionId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class PassportDocumentTypesId {
  private constructor() {}

  "PassportDocumentTypesId": PassportDocumentTypesId;

  public static wrap(id: number): PassportDocumentTypesId {
    return <any>id;
  }

  public static unwrap(val: PassportDocumentTypesId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class PassportCategoryId {
  private constructor() {}

  "PassportCategoryId": PassportCategoryId;

  public static wrap(id: number): PassportCategoryId {
    return <any>id;
  }

  public static unwrap(val: PassportCategoryId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class CaregiverDocumentUploadId {
  private constructor() {}

  "CaregiverDocumentUploadId": CaregiverDocumentUploadId;

  public static wrap(id: number): CaregiverDocumentUploadId {
    return <any>id;
  }

  public static unwrap(val: CaregiverDocumentUploadId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class VisitInstanceId {
  private constructor() {}

  "VisitInstanceId": VisitInstanceId;

  public static wrap(id: number): VisitInstanceId {
    return <any>id;
  }

  public static unwrap(visitInstanceId: VisitInstanceId): number {
    return <any>visitInstanceId;
  }
}

/** @TJS-type number */
export class ICD10CodeId {
  private constructor() {}

  "ICD10CodeId": ICD10CodeId;

  public static wrap(id: number): ICD10CodeId {
    return <any>id;
  }

  public static unwrap(val: ICD10CodeId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class PatientContractDiagnosisCodeId {
  private constructor() {}

  "PatientContractDiagnosisCodeId": PatientContractDiagnosisCodeId;

  public static wrap(id: number): PatientContractDiagnosisCodeId {
    return <any>id;
  }

  public static unwrap(val: PatientContractDiagnosisCodeId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class ScheduledVisitId {
  private constructor() {}

  "ScheduledVisitId": ScheduledVisitId;

  public static wrap(id: number): ScheduledVisitId {
    return <any>id;
  }

  public static unwrap(scheduledVisitId: ScheduledVisitId): number {
    return <any>scheduledVisitId;
  }
}

/** @TJS-type number */
export class CoronaReportQuestionId {
  private constructor() {}

  "CoronaReportQuestionId": CoronaReportQuestionId;

  public static wrap(id: number): CoronaReportQuestionId {
    return <any>id;
  }

  public static unwrap(coronaReportQuestionId: CoronaReportQuestionId): number {
    return <any>coronaReportQuestionId;
  }
}

/** @TJS-type number */
export class CoronaReportAnswerId {
  private constructor() {}

  "CoronaReportQuestionId": CoronaReportAnswerId;

  public static wrap(id: number): CoronaReportAnswerId {
    return <any>id;
  }

  public static unwrap(coronaReportAnswerId: CoronaReportAnswerId): number {
    return <any>coronaReportAnswerId;
  }
}

/** @TJS-type number */
export class TrainingCenterBundleId {
  private constructor() {}

  "TrainingCenterBundleId": TrainingCenterBundleId;

  public static wrap(id: number): TrainingCenterBundleId {
    return <any>id;
  }

  public static unwrap(val: TrainingCenterBundleId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class TrainingCenterBundleDueDateId {
  private constructor() {}

  "TrainingCenterBundleDueDateId": TrainingCenterBundleDueDateId;

  public static wrap(id: number): TrainingCenterBundleDueDateId {
    return <any>id;
  }

  public static unwrap(val: TrainingCenterBundleDueDateId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class TrainingCenterBundleItemId {
  private constructor() {}

  "TrainingCenterBundleItemId": TrainingCenterBundleItemId;

  public static wrap(id: number): TrainingCenterBundleItemId {
    return <any>id;
  }

  public static unwrap(val: TrainingCenterBundleItemId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class TrainingCenterBundleItemPayloadId {
  private constructor() {}

  "TrainingCenterBundleItemPayloadId": TrainingCenterBundleItemPayloadId;

  public static wrap(id: number): TrainingCenterBundleItemPayloadId {
    return <any>id;
  }

  public static unwrap(val: TrainingCenterBundleItemPayloadId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class TrainingCenterBundleItemTestQuestionId {
  private constructor() {}

  "TrainingCenterBundleItemTestQuestionId": TrainingCenterBundleItemTestQuestionId;

  public static wrap(id: number): TrainingCenterBundleItemTestQuestionId {
    return <any>id;
  }

  public static unwrap(val: TrainingCenterBundleItemTestQuestionId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class TrainingCenterBundleItemTestVersionId {
  private constructor() {}

  "TrainingCenterBundleItemTestVersionId": TrainingCenterBundleItemTestVersionId;

  public static wrap(id: number): TrainingCenterBundleItemTestVersionId {
    return <any>id;
  }

  public static unwrap(val: TrainingCenterBundleItemTestVersionId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class TrainingCenterBundleItemVideoEngmtQuestionId {
  private constructor() {}

  "TrainingCenterBundleItemVideoEngmtQuestionId": TrainingCenterBundleItemVideoEngmtQuestionId;

  public static wrap(id: number): TrainingCenterBundleItemVideoEngmtQuestionId {
    return <any>id;
  }

  public static unwrap(val: TrainingCenterBundleItemVideoEngmtQuestionId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class MedicationId {
  private constructor() {}

  "MedicationId": MedicationId;

  public static wrap(id: number): MedicationId {
    return <any>id;
  }

  public static unwrap(val: MedicationId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class NursingQuestionId {
  private constructor() {}

  "NursingQuestionId": NursingQuestionId;

  public static wrap(id: number): NursingQuestionId {
    return <any>id;
  }

  public static unwrap(id: NursingQuestionId): number {
    return <any>id;
  }
}

/** @TJS-type number */
export class PatientMedicationProfileId {
  private constructor() {}

  "PatientMedicationProfileId": PatientMedicationProfileId;

  public static wrap(id: number): PatientMedicationProfileId {
    return <any>id;
  }

  public static unwrap(val: PatientMedicationProfileId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class OfficeId {
  private constructor() {}

  "OfficeId": OfficeId;

  public static wrap(id: number): OfficeId {
    return <any>id;
  }

  public static unwrap(officeId: OfficeId): number {
    return <any>officeId;
  }
}

/** @TJS-type number */
export class VBPItemId {
  private constructor() {}

  "VBPItemId": VBPItemId;

  public static wrap(id: number): VBPItemId {
    return <any>id;
  }

  public static unwrap(val: VBPItemId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class CaregiverDocumentTypeId {
  private constructor() {}

  "CaregiverDocumentTypeId": CaregiverDocumentTypeId;

  public static wrap(id: number): CaregiverDocumentTypeId {
    return <any>id;
  }

  public static unwrap(val: CaregiverDocumentTypeId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class CaregiverSurveyQuestionId {
  private constructor() {}

  "CaregiverSurveyQuestionId": CaregiverSurveyQuestionId;

  public static wrap(id: number): CaregiverSurveyQuestionId {
    return <any>id;
  }

  public static unwrap(val: CaregiverSurveyQuestionId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class PatientTaskId {
  private constructor() {}

  "PatientTaskId": PatientTaskId;

  public static wrap(id: number): PatientTaskId {
    return <any>id;
  }

  public static unwrap(val: PatientTaskId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class CaregiverSurveyQuestionAnswerId {
  private constructor() {}

  "CaregiverSurveyQuestionAnswerId": CaregiverSurveyQuestionAnswerId;

  public static wrap(id: number): CaregiverSurveyQuestionAnswerId {
    return <any>id;
  }

  public static unwrap(val: CaregiverSurveyQuestionAnswerId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class PatientTaskInstanceId {
  private constructor() {}

  "PatientTaskInstanceId": PatientTaskInstanceId;

  public static wrap(id: number): PatientTaskInstanceId {
    return <any>id;
  }

  public static unwrap(val: PatientTaskInstanceId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class PatientDocumentScheduleId {
  private constructor() {}

  "PatientDocumentScheduleId": PatientDocumentScheduleId;

  public static wrap(id: number): PatientDocumentScheduleId {
    return <any>id;
  }

  public static unwrap(val: PatientDocumentScheduleId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class AllergyId {
  private constructor() {}

  "AllergyId": AllergyId;

  public static wrap(id: number): AllergyId {
    return <any>id;
  }

  public static unwrap(val: AllergyId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class TrainingCenterBundleItemFullDescriptionId {
  private constructor() {}

  "TrainingCenterBundleItemFullDescriptionId": TrainingCenterBundleItemFullDescriptionId;

  public static wrap(id: number): TrainingCenterBundleItemFullDescriptionId {
    return <any>id;
  }

  public static unwrap(val: TrainingCenterBundleItemFullDescriptionId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class TrainingCenterBundleItemVideoMediaOverlayId {
  private constructor() {}

  "TrainingCenterBundleItemVideoMediaOverlayId": TrainingCenterBundleItemVideoMediaOverlayId;

  public static wrap(id: number): TrainingCenterBundleItemVideoMediaOverlayId {
    return <any>id;
  }

  public static unwrap(val: TrainingCenterBundleItemVideoMediaOverlayId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class PatientContractId {
  private constructor() {}

  "PatientContractId": PatientContractId;

  public static wrap(id: number): PatientContractId {
    return <any>id;
  }

  public static unwrap(val: PatientContractId): number {
    return <any>val;
  }
}

/** @TJS-type string */
export class CaregiverCertification {
  private constructor() {}

  "CaregiverCertification": CaregiverCertification;

  public static wrap(name: string): CaregiverCertification {
    return <any>name;
  }

  public static unwrap(val: CaregiverCertification): string {
    return <any>val;
  }
}

/** @TJS-type number */
export class CommCenterTeamId {
  private constructor() {}

  "CommCenterTeamId": CommCenterTeamId;

  public static wrap(id: number): CommCenterTeamId {
    return <any>id;
  }

  public static unwrap(val: CommCenterTeamId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class CommCenterTeamMemberId {
  private constructor() {}

  "CommCenterTeamMemberId": CommCenterTeamMemberId;

  public static wrap(id: number): CommCenterTeamMemberId {
    return <any>id;
  }

  public static unwrap(val: CommCenterTeamMemberId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class CommCenterTicketId {
  private constructor() {}

  "CommCenterTicketId": CommCenterTicketId;

  public static wrap(id: number): CommCenterTicketId {
    return <any>id;
  }

  public static unwrap(val: CommCenterTicketId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class CommCenterLabelId {
  private constructor() {}

  "CommCenterLabelId": CommCenterLabelId;

  public static wrap(id: number): CommCenterLabelId {
    return <any>id;
  }

  public static unwrap(val: CommCenterLabelId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class CommCenterMessageActionId {
  private constructor() {}

  "CommCenterMessageActionId": CommCenterMessageActionId;

  public static wrap(id: number): CommCenterMessageActionId {
    return <any>id;
  }

  public static unwrap(val: CommCenterMessageActionId): number {
    return <any>val;
  }
}

/** @TJS-type number */
export class CommCenterMessageId {
  private constructor() {}

  "CommCenterMessageId": CommCenterMessageId;

  public static wrap(id: number): CommCenterMessageId {
    return <any>id;
  }

  public static unwrap(val: CommCenterMessageId): number {
    return <any>val;
  }
}

/**
 * @TJS-format ComplianceFormDocumentId
 * @TJS-type number
 */
export class ComplianceFormDocumentId {
  private constructor() {}
  "ComplianceFormDocumentId": ComplianceFormDocumentId;
  public static wrap(id: number): ComplianceFormDocumentId {
    return <any>id;
  }
  public static unwrap(id: ComplianceFormDocumentId): number {
    return <any>id;
  }
}

/**
 * @TJS-format ComplianceFormQuestionId
 * @TJS-type number
 */
export class ComplianceFormQuestionId {
  private constructor() {}
  "ComplianceFormQuestionId": ComplianceFormQuestionId;
  public static wrap(id: number): ComplianceFormQuestionId {
    return <any>id;
  }
  public static unwrap(id: ComplianceFormQuestionId): number {
    return <any>id;
  }
}

/**
 * @TJS-format ComplianceFormQuestionOptionId
 * @TJS-type number
 */
export class ComplianceFormQuestionOptionId {
  private constructor() {}
  "ComplianceFormQuestionOptionId": ComplianceFormQuestionOptionId;
  public static wrap(id: number): ComplianceFormQuestionOptionId {
    return <any>id;
  }
  public static unwrap(id: ComplianceFormQuestionOptionId): number {
    return <any>id;
  }
}

/**
 * @TJS-format ComplianceFormRecordId
 * @TJS-type number
 */
export class ComplianceFormRecordId {
  private constructor() {}
  "ComplianceFormRecordId": ComplianceFormRecordId;
  public static wrap(id: number): ComplianceFormRecordId {
    return <any>id;
  }
  public static unwrap(id: ComplianceFormRecordId): number {
    return <any>id;
  }
}

/**
 * @TJS-format ComplianceFormAnswerId
 * @TJS-type number
 */
export class ComplianceFormAnswerId {
  private constructor() {}
  "ComplianceFormAnswerId": ComplianceFormAnswerId;
  public static wrap(id: number): ComplianceFormAnswerId {
    return <any>id;
  }
  public static unwrap(id: ComplianceFormAnswerId): number {
    return <any>id;
  }
}

/**
 * @TJS-format InstaPayBankId
 * @TJS-type number
 */
export class InstaPayBankId {
  private constructor() {}
  "InstaPayBankId": InstaPayBankId;
  public static wrap(id: number): InstaPayBankId {
    return <any>id;
  }
  public static unwrap(id: InstaPayBankId): number {
    return <any>id;
  }
}

/**
 * @TJS-format InstaPayBankAccountTypeId
 * @TJS-type number
 */
export class InstaPayBankAccountTypeId {
  private constructor() {}
  "InstaPayBankAccountTypeId": InstaPayBankAccountTypeId;
  public static wrap(id: number): InstaPayBankAccountTypeId {
    return <any>id;
  }
  public static unwrap(id: InstaPayBankAccountTypeId): number {
    return <any>id;
  }
}

/**
 * @TJS-format CareMomentsRankId
 * @TJS-type number
 */
export class CareMomentsRankId {
  private constructor() {}
  "CareMomentsRankId": CareMomentsRankId;
  public static wrap(id: number): CareMomentsRankId {
    return <any>id;
  }
  public static unwrap(id: CareMomentsRankId): number {
    return <any>id;
  }
}

/**
 * @TJS-format CareMomentsAdjustmentId
 * @TJS-type number
 */
export class CareMomentsAdjustmentId {
  private constructor() {}
  "CareMomentAdjustmentId": CareMomentsAdjustmentId;
  public static wrap(id: number): CareMomentsAdjustmentId {
    return <any>id;
  }
  public static unwrap(id: CareMomentsAdjustmentId): number {
    return <any>id;
  }
}

/**
 * @TJS-format NotePredefinedAnswerId
 * @TJS-type number
 */
export class NotePredefinedAnswerId {
  private constructor() {}

  "NotePredefinedAnswerId": NotePredefinedAnswerId;

  public static wrap(id: number): NotePredefinedAnswerId {
    return <any>id;
  }

  public static unwrap(val: NotePredefinedAnswerId): number {
    return <any>val;
  }
}
